import { c as _c } from "react/compiler-runtime";
import { LogOut, Package } from "react-feather";
import { Gift } from "lucide-react";
import { UserDropdownProps } from "./types";
import Link from "next/link";
const UserDropdown: React.FC<UserDropdownProps> = t0 => {
  const $ = _c(10);
  const {
    onLogout,
    position: t1,
    onLinkClick
  } = t0;
  const position = t1 === undefined ? "right" : t1;
  const positionClasses = position === "left" ? "left-0" : "right-0";
  const t2 = `absolute top-full mt-2 ${positionClasses} w-52 bg-white/95 backdrop-blur-md rounded-2xl shadow-[0_10px_40px_rgba(0,0,0,0.1)] py-2 z-[60] border border-gray-100/50 transform origin-top-right transition-all duration-200`;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Package className="w-4 h-4 mr-3 text-gray-400 group-hover:text-[#037A6A] transition-colors" />;
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] !== onLinkClick) {
    t4 = <Link href="/my-orders" onClick={onLinkClick} className="flex items-center mx-2 px-3 py-2.5 text-sm font-medium text-gray-600 hover:text-[#037A6A] hover:bg-gray-50/80 rounded-xl transition-all duration-200 group">{t3}My Orders</Link>;
    $[1] = onLinkClick;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <LogOut className="w-4 h-4 mr-3 text-gray-400 group-hover:text-red-500 transition-colors" />;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== onLogout) {
    t6 = <button onClick={onLogout} className="flex items-center w-[calc(100%-16px)] mx-2 px-3 py-2.5 text-sm font-medium text-gray-600 hover:text-red-600 hover:bg-red-50/50 rounded-xl transition-all duration-200 group mt-1">{t5}Logout</button>;
    $[4] = onLogout;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== t2 || $[7] !== t4 || $[8] !== t6) {
    t7 = <div className={t2}>{t4}{t6}</div>;
    $[6] = t2;
    $[7] = t4;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  return t7;
};
export default UserDropdown;